import { render, staticRenderFns } from "./ReviewCardSupplements.vue?vue&type=template&id=7d442226&scoped=true&"
import script from "./ReviewCardSupplements.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardSupplements.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardSupplements.vue?vue&type=style&index=0&id=7d442226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d442226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d442226')) {
      api.createRecord('7d442226', component.options)
    } else {
      api.reload('7d442226', component.options)
    }
    module.hot.accept("./ReviewCardSupplements.vue?vue&type=template&id=7d442226&scoped=true&", function () {
      api.rerender('7d442226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardSupplements.vue"
export default component.exports